// React imports
import React, { useState } from 'react';

// Mui imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';

// Local imports
import AccountsMainFilters from './dashboard/accounts/AccountsMain.filters.js';

function AudienceDetails() {
  return (
    <div>
      <h1>Audience Details</h1>
    </div>
  );
}

function AudienceDetailsInner(props) {
    const { initialAccounts, initialFilter, initialContinousFilterDates, allAccounts, seaPorts } = props;
    const [ title, setTitle ] = useState('');
    const [ description, setDescription ] = useState('');
    const [ filtersActive, setFiltersActive ] = useState(!!initialFilter);
    const [ filter, setFilter ] = useState(initialFilter);
    const [ continuousFilterDates, setContinuousFilterDates ] = useState(false);

    return (
        <>
            <Box sx={{ width: '400px', mb: 1 }}>
                <TextField
                    fullWidth
                    value={title}
                    onChange={(event) => setTitle(event.target.value)}
                    label={'Title'}
                    sx={{ mb: 2 }}
                />
                <TextField
                    fullWidth
                    value={description}
                    onChange={(event) => setDescription(event.target.value)}
                    label={'Description'}
                    sx={{ mb: 2 }}
                />
            </Box>
            <Typography variant='h6' sx={{ mb: 1 }}>
                Accounts
            </Typography>
            {!initialAccounts && (
                <Typography variant='body2' sx={{ mb: 2, fontStyle: 'italic' }}>
                    To add accounts, create new audience from the Accounts page.
                </Typography>
            )}
            {initialAccounts && (
                <Box>
                    <Typography variant='body2' sx={{ mb: 2 }}>
                        Audience contains {initialAccounts.length} accounts. <Button color='primary' variant= 'text' sx={{ textTransform: 'none', minWidth: 0, padding: '0px' }} onClick={() => {}}>Show list</Button>
                    </Typography>
                </Box>
            )}
            <Typography variant='h6' sx={{ mb: 1 }}>
                Account Filters
            </Typography>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={filtersActive}
                        onChange={() => setFiltersActive(f => !f)}
                    color='primary'
                    />
                }
                label={<Typography variant='body2'>Continuously update accounts with filter</Typography>}
            />
            {(filter.advanced.lastActivity?.length > 0 || filter.advanced.dateCreated?.length > 0) && filtersActive && (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!continuousFilterDates}
                            onChange={() => setContinuousFilterDates(f => !f)}
                        color='primary'
                        />
                    }
                    label={<Typography variant='body2'>Keep dates constant, do not advance them.</Typography>}
                />
            )}
            {filtersActive && (
                <AccountsMainFilters filter={filter} setFilter={setFilter} accounts={allAccounts} seaPorts={seaPorts} />
            )}
        </>
    );
}

export default AudienceDetails;
export{ AudienceDetailsInner };
